export default __webpack_public_path__ + "fonts/error-check-circle.svg";